import { RecentMatchOutcome } from '@hooks/useRecentMatchOutcomes'
import translate from '@i18n'

const getOutcomeTypeText = (type: RecentMatchOutcome['type']) => {
  return translate(`recentMatchOutcomes.type.${type}`).charAt(0)
}

export { getOutcomeTypeText }
